// extracted by mini-css-extract-plugin
module.exports = {"sidebar":"VideoSidebar_sidebar__18tnp","overflow":"VideoSidebar_overflow__3WyAC","hideChat":"VideoSidebar_hideChat__3nikX"};